/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const BOOTSTRAP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        //url: "https://staging-api-parametro.klefki.io/core/v1/graphql/",
        //  url: "http://localhost:6101/graphql",
        url:"https://api-parametro.klefki.io/core/v1/graphql/",
        // url:"https://wsrtmprm-6111.inc1.devtunnels.ms/",
      },
    ],
    rest: {
      loginServer: {
        // baseURL: "http://localhost:6102",
      // baseURL: "https://staging-api-parametro.klefki.io/iam/v1",
      baseURL:"https://api-parametro.klefki.io/iam/v1",
        // baseURL:"https://demo-api-parametro.klefki.io/iam/v1"
      },
    },
  },
};
